var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcConsent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.5 27c0 .55-.45 1-1 1h-6c-2.21 0-4-1.79-4-4v-16c0-2.21 1.79-4 4-4h14c2.21 0 4 1.79 4 4v8c0 .55-.45 1-1 1s-1-.45-1-1v-8c0-1.1-.9-2-2-2h-14c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h6c.55 0 1 .45 1 1zm5.97-17c0-.55-.45-1-1-1h-9.97c-.55 0-1 .45-1 1s.45 1 1 1h9.97c.55 0 1-.45 1-1zm-2 5c0-.55-.45-1-1-1h-7.97c-.55 0-1 .45-1 1s.45 1 1 1h7.97c.55 0 1-.45 1-1zm-8.97 4c-.55 0-1 .45-1 1s.45 1 1 1h2.97c.55 0 1-.45 1-1s-.45-1-1-1zm16.71 1.29c-.39-.39-1.02-.39-1.41 0l-5.29 5.29-2.29-2.29c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41l3 3c.2.2.45.29.71.29s.51-.1.71-.29l6-6c.39-.39.39-1.02 0-1.41z",
    fill: "#555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConsent);
export default __webpack_public_path__ + "static/media/ic-consent.6bdc82d22f2cc1ea1a9144ede35857fc.svg";
export { ForwardRef as ReactComponent };